import { getRequestData } from '@/utils';
// import isEmpty from 'lodash/isEmpty';
import { newConnection, qryBBVPNDomain } from '@/pages/NewConnection/services';

export default {
  namespace: 'newConnection',
  state: {
    step: 0, // 开户的步骤
    isCreate: false, // 是否新建
    searchCustInfo: {}, // 从搜索页面同步过来的用户信息
    serviceType: {}, // 从搜索页面同步过来的服务类型
    offerSelectionDetail: null, // offerSelection 数据 {}
    relatedOfferList: null, // combo relatedOffer数据 []
    attrbuteDetail: null, // ISDN attrbuteInfo数据 {}
  },
  effects: {
    // 新开
    *newConnection({ payload }, { call }) {
      const response = yield call(newConnection, payload);
      return getRequestData(response);
    },
    *qryBBVPNDomain({ payload }, { call }) {
      const response = yield call(qryBBVPNDomain, payload);
      const { domainDtoList } = getRequestData(response);
      return domainDtoList || [];
    },
    *clearModelsInfo({ models }, { put }) { // models 为字符串数组，元素为要清除的model的namespace
      yield models.map(model => put({ type: `${model}/clear` }));
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clearBaseInfo() {
      return {
        step: 0,
        isCreate: false,
        searchCustInfo: {},
        offerSelectionDetail: null, // offerSelection 数据
        relatedOfferList: null, // combo relatedOffer数据
        attrbuteDetail: null, // ISDN attrbuteInfo数据
      };
    },
  },
};
